import React, { useEffect, useState } from "react";
import { AESEncryption, ApiResDecrypt, decryptData, noDataFound } from "../../../CommonMethhods/CommonMethods";
import moment from "moment";
import { DASHBOARD_CLIENT_DETAIL_EQUITY } from "../../../Configuration/API_URL";
import CalendarIcon from "../../../asset/images/calender.svg";
import { compareDate } from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";
import { numDifferentiation } from "../../../CommonMethhods/CovertRupees";
import SmallLoader from "../../../Components/Common/smallLoader";
import { partner_Api } from "../../../Configuration/Partner_URL";
import { axiosSsoJsonReserv1 } from "../../../CommonMethhods/axiosPartnerInterceptor";

function PartnerDividendInfo() {
  const PartnerClientCode = localStorage.getItem("ClientId2");
  const storeToken = localStorage.getItem("ssoToken");
  const [dividendInfo, setDividendInfo] = useState({});
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [fromDateVal, setFromDateVal] = useState(" ");
  const [toDateVal, setToDateVal] = useState(" ");
  const [checkDate, setCheckDate] = useState(false);
  const [error, setError] = useState("");

  // useEffect(() => {
  if (fromDate == "" || toDate == "") {
    const current = new Date();
    const CurrentYear = current.getFullYear();
    const CurrentMonth = current.getMonth();
    if (CurrentMonth < 4) {
      const newYear = `04-01-${CurrentYear - 1}`;
      const date = `${
        current.getMonth() + 1
      }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    } else {
      const newYear = `04-01-${CurrentYear}`;
      const date = `${
        current.getMonth() + 1
      }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      // alert("2")
      setFromDate(newYear);
      setToDate(date1);
    }
  }
  // }, []);
  let clientCode = "";

  const getDividendInfo = async (clientCode) => {
    let payloadValue = {
      clientCode: clientCode,
      fromDate: fromDate,
      toDate: toDate,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      setLoader(true);
      const getDetails = await axiosSsoJsonReserv1.post(
        DASHBOARD_CLIENT_DETAIL_EQUITY.DividendInfo_URL,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      // let decryptedRes = JSON.parse(res);

      if (res?.data !== "") {
        setDividendInfo(res?.data);
      } else {
        setDividendInfo({});
      }

      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    setError("");
    if (fromDate.length > 0 && toDate.length > 0) {
      if (PartnerClientCode) {
        clientCode = PartnerClientCode;
        getDividendInfo(clientCode);
        setCheckDate(false);
      } else {
        setLoader(false);
      }
    }
  }, []);

  const handleFromDateChange = (e) => {
    let c = e.target.value;
    setFromDateVal(c);
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setDividendInfo({});
    setError("");
  };
  const handleToDateChange = (e) => {
    let c = e.target.value;
    setToDateVal(c);
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setError("");
    setDividendInfo({});
  };

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const handleOnClick = () => {
    if (PartnerClientCode) {
      if (compareDate(fromDate) && compareDate(toDate)) {
        setError("");
        getDividendInfo(clientCode);
      } else {
        setCheckDate(true);
        setError("Please Select Correct Date");
      }
    }
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  return (
    <>
      <div className="col-12 col-lg-6">
        <div className="card-box dividend">
          <div className="card-title">
            <div className="figure-inlac">
              <h2>{Constants.Dividend_Info}</h2>
              {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
            </div>

            <div className="filter-options">
              {/* <!-- pdf icons --> */}
              <a className="pdf-icon" href="#">
                <img src="asset/images/pdf.svg" alt="" />
              </a>
            </div>
          </div>

          <div className="dividend__info">
            <div className="dividend__info__from">
              {/* dividend details */}
              <div className="dividend__details">
                {/* <a className="pdf-icon" href="#">
                  <span className=" site-icons icon-calendar"></span>
                </a> */}

                <div action="" className="dividend-form">
                  <img src={CalendarIcon} alt="" className="calender-icon" />
                  <label htmlFor="from">{Constants.From}</label>
                  <input
                    type="date"
                    placeholder="DD/MM/YYYY"
                    className="datepicker"
                    onChange={handleFromDateChange}
                    defaultValue={formatDate(fromDate)}
                    id="FromDate"
                    max={DateReverse}
                  />
                  <label htmlFor="to">{Constants.To}</label>
                  <input
                    type="date"
                    placeholder="DD/MM/YYYY"
                    className="datepicker"
                    onChange={handleToDateChange}
                    defaultValue={formatDate(toDate)}
                    id="ToDate"
                    max={DateReverse}
                  />
                  <span className="to-date-error">{error}</span>
                  {/* <input type="submit" className="date-search" onClick={getDividendInfo} > */}
                  <input
                    type="submit"
                    className="date-search"
                    onClick={handleOnClick}
                  >
                    {/* <span className="site-icons icon-search-bar"></span> */}
                  </input>
                </div>
              </div>
            </div>

            <div>
              <table className="table equal-column-width-md">
                <tbody>
                  <tr>
                    <td scope="col">{Constants.Total_Companies}</td>
                    <td>
                      {loader ? (
                        <div className="d-unset">
                          <SmallLoader />
                        </div>
                      ) : (
                        <>
                          {dividendInfo === "" || undefined || null
                            ? "0"
                            : dividendInfo?.totalcompanies === undefined || null
                            ? "0"
                            : dividendInfo?.totalcompanies}
                        </>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td scope="col">{Constants.Total_Shares}</td>
                    <td>
                      {loader ? (
                        <div className="d-unset">
                          <SmallLoader />
                        </div>
                      ) : (
                        <>
                          {dividendInfo === "" || undefined || null
                            ? "0"
                            : dividendInfo?.totalshares === undefined || null
                            ? "0"
                            : dividendInfo?.totalshares}
                        </>
                      )}
                    </td>
                  </tr>
                  <tr className="total-dividend">
                    <td scope="col">{Constants.Total_Dividend}</td>
                    <td>
                      {loader ? (
                        <div className="d-unset">
                          <SmallLoader />
                        </div>
                      ) : (
                        <>
                          <span>₹</span>

                          {dividendInfo === "" || undefined || null
                            ? "0"
                            : dividendInfo?.totaldividend === undefined || null
                            ? "0"
                            : numDifferentiation(dividendInfo?.totaldividend)}
                        </>
                      )}
                    </td>
                  </tr>
                </tbody>
                {/* {dividendInfo === undefined || null ? (
              noDataFound()
            ) : (
              <tbody>{showDividendData(dividendInfo)}</tbody>
            )} */}
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PartnerDividendInfo;
